module.exports = __webpack_public_path__ + "static/media/Office_5.a08c929f.jpg";